import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { VideoObject } from '../../interfaces/responsedata.ts/generic-streams';

@Component({
  selector: 'app-promotion-video-popup',
  standalone: false,
  templateUrl: './promotion-video-popup.component.html',
  styleUrl: './promotion-video-popup.component.scss'
})
export class PromotionVideoPopupComponent implements OnInit {
    data:VideoObject = inject(MAT_DIALOG_DATA);
    dia = inject(MatDialogRef<PromotionVideoPopupComponent>)
    private destroyRef = inject(DestroyRef);
    private sanitizer = inject(DomSanitizer);
    safeUrl: SafeUrl | null = null;

    ngOnInit() {
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url);
    }

    close() {
        this.dia.close();
    }
}
